import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classes from './index.scss';
import classNames from 'classnames';

class Tooltip extends Component {

  state = {
    tipTop: 250,
    show: false,
  }

  updateTopPosition() {
    const tipHeight = this._tipEl ? this._tipEl.getBoundingClientRect().height : 250;
    const tipTop = (tipHeight / 2) * -1;
    if (tipTop !== this.state.tipTop) this.setState({ tipTop });
  }

  componentDidMount() {
    this.updateTopPosition();
  }

  componentDidUpdate() {
    this.updateTopPosition();
  }
  checkForList() {
    if(this.props.multiline) {
      return (<div>

            <div className={ classes.reqtooltip }>
              { this.props.length }
            </div>

            <div className= {classes.reqtooltip}>
              { this.props.letter }
            </div>

            <div className= {classes.reqtooltip}>
              { this.props.digit }
            </div>

            <div className= {classes.reqtooltip}>
              { this.props.special }
            </div>

      </div>);
    }
  }

  toggleDisplay = () => {
    const show = !this.state.show;
    this.setState({ show });
  }

  render() {
    const tipStyles = {
      top: this.state.tipTop,
    };

    const wrapperClasses = classNames({
      [classes.tooltip]: true,
      [this.props.className]: typeof this.props.className === "string",
    });

    const tipClasses = classNames(
      {
        [classes.show]: this.state.show,
        [classes.tip]: true,
      });

    return (
      <div className={ wrapperClasses } >

        <span
          className={ classes["icon-question-sign"] }
          onMouseEnter={ this.toggleDisplay }
          onMouseLeave={ this.toggleDisplay }
        >
        </span>

        <div className={ tipClasses } style={ tipStyles } ref={ (c) => { this._tipEl = c } }>
          <div className={ classes["arrow-left"] }>
            <div className={ classes["inner-arrow"] }></div>
          </div>

          <div className={ classes.title }>
            { this.props.title }
          </div>

          <div className={ classes.content }>
            { this.props.content }
          </div>

          <div>
            { this.checkForList() }
          </div>
        </div>
      </div>
    );
  }
}

Tooltip.propTypes = {
  className: PropTypes.string,
  content: PropTypes.string,
  title: PropTypes.string.isRequired,
  length: PropTypes.string,
  letter: PropTypes.string,
  digit: PropTypes.string,
  special: PropTypes.string,
};

export default Tooltip;
